import { addLocaleData } from 'react-intl';
import de from 'react-intl/locale-data/de';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import fr from 'react-intl/locale-data/fr';
import it from 'react-intl/locale-data/it';
import ja from 'react-intl/locale-data/ja';
import pt from 'react-intl/locale-data/pt';

import messages from './messages';

function getQueryStringValue(name) {
  const url = window.testLocation || window.location.href;

  const formattedName = name.replace(/[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${formattedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return '';

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function isLanguageSupported(lang) {
  return messages[lang] !== undefined;
}

function getBestSupportedLanguage(mcLocale) {
  const queryStringLocale = getQueryStringValue('locale');
  const calculatedLanguage =
    queryStringLocale ||
    mcLocale ||
    navigator.userLanguage ||
    navigator.language ||
    'en';
  let selectedLanguage = 'en';

  // 1) try with full locale (with region) given ex) fr-CA
  // 2) try without region only fr for fr-CA
  // 3) fallback to en
  if (isLanguageSupported(calculatedLanguage)) {
    // with region (if provided) fr-CA
    selectedLanguage = calculatedLanguage;
  } else {
    const baseLocale = calculatedLanguage.split(/-(.+)?/)[0];
    if (isLanguageSupported(baseLocale)) {
      selectedLanguage = baseLocale;
    }
  }

  return selectedLanguage;
}

class I18nLoader {
  constructor(mcLocale) {
    this.selectedLanguage = getBestSupportedLanguage(mcLocale);
    addLocaleData([...de, ...en, ...es, ...fr, ...it, ...ja, ...pt]);
  }

  get messages() {
    const languages = [messages.en];
    if (this.selectedLanguage !== 'en') {
      languages.push(messages[this.selectedLanguage]);
    }
    return Object.assign({}, ...languages);
  }

  get locale() {
    return this.selectedLanguage;
  }
}

export default I18nLoader;
